import { FEATURE_FLAGS } from "reducer/auth.reducer";
import { ISetExpConfigurations } from "../interfaces/auth.interface";

const activeFeatureFlags: string[] = Object.values(FEATURE_FLAGS)
  .filter((flag) => !flag.showByDefault)
  .map((flag) => flag.title);

export function setExpConfigurations(data: string[]): ISetExpConfigurations {
  return {
    type: "SET_EXP_CONFIGURATIONS",
    data: data.filter((flag) => activeFeatureFlags.includes(flag)),
  };
}
